import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys(Object(t), !0)).call(_context4, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
//@ts-nocheck
import React from "react";
import FieldBase from "componentLibrary/Fields/FieldBase";
import { ListItemText, MenuItem, Select, Typography, makeStyles } from "components/mui";
import { RaiseColors, Icon } from "componentLibrary";
import classNames from "classnames";
import { TrackSetEnum } from "utils/Enums";
import { getEnumLabel } from "utils/enumUtils";
import { OVERLAY_MENU_Z_INDEX } from "utils/constants";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = makeStyles(function () {
  return {
    root: {
      borderRadius: "20px"
    },
    marketStatsIcon: {
      color: RaiseColors.onMarket
    },
    brokerPriorityIcon: {
      color: RaiseColors.alarm
    },
    notTrackedIcon: {
      color: RaiseColors.warning
    },
    noStatusIcon: {
      color: RaiseColors.gray200
    }
  };
});
function TrackSetSelectField(_ref) {
  var _context, _context2, _context3;
  var value = _ref.value,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var options = _mapInstanceProperty(_context = _sortInstanceProperty(_context2 = _Object$values(_valuesInstanceProperty(TrackSetEnum))).call(_context2, function (a, b) {
    return a.order - b.order;
  })).call(_context, function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value,
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? "" : _ref2$description;
    return {
      label: label,
      value: value,
      description: description
    };
  });
  return /*#__PURE__*/_jsx(FieldBase, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx(Select, {
      MenuProps: {
        disablePortal: false,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        sx: {
          zIndex: OVERLAY_MENU_Z_INDEX
        }
      },
      value: value,
      onChange: onChange,
      disableUnderline: true,
      className: classes.root,
      "native": false,
      renderValue: function renderValue(value) {
        return /*#__PURE__*/_jsxs("div", {
          style: {
            display: "flex",
            alignItems: "center"
          },
          children: [/*#__PURE__*/_jsx(Icon, {
            className: classNames("fas fa-circle", _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.marketStatsIcon, value === TrackSetEnum.MARKET_STATS.value), classes.brokerPriorityIcon, value === TrackSetEnum.BROKER_PRIORITY.value), classes.notTrackedIcon, value === TrackSetEnum.NOT_TRACKED.value), classes.noStatusIcon, value === TrackSetEnum.NO_STATUS.value)),
            fontSize: 10,
            style: {
              paddingRight: 18
            }
          }), /*#__PURE__*/_jsx(ListItemText, {
            disableTypography: true,
            primary: getEnumLabel(TrackSetEnum, value)
          })]
        });
      },
      children: _mapInstanceProperty(_context3 = _filterInstanceProperty(options).call(options, function (option) {
        return option.value !== "";
      })).call(_context3, function (option, index) {
        return /*#__PURE__*/_jsx(MenuItem, {
          value: option.value,
          children: /*#__PURE__*/_jsxs("div", {
            style: {
              display: "flex",
              alignItems: "center",
              paddingRight: 28,
              paddingLeft: 22
            },
            children: [/*#__PURE__*/_jsx(Icon, {
              className: classNames("fas fa-circle", _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, classes.marketStatsIcon, option.value === TrackSetEnum.MARKET_STATS.value), classes.brokerPriorityIcon, option.value === TrackSetEnum.BROKER_PRIORITY.value), classes.notTrackedIcon, option.value === TrackSetEnum.NOT_TRACKED.value), classes.noStatusIcon, option.value === TrackSetEnum.NO_STATUS.value)),
              fontSize: 10,
              style: {
                paddingRight: 18
              }
            }), /*#__PURE__*/_jsx(ListItemText, {
              disableTypography: true,
              primary: option.label,
              secondary: /*#__PURE__*/_jsx(_Fragment, {
                children: option.description ? /*#__PURE__*/_jsx(Typography, {
                  component: "p",
                  variant: "paragraph_xsmall",
                  color: RaiseColors.gray300,
                  children: option.description
                }) : null
              })
            })]
          })
        }, index);
      })
    })
  }));
}
export default TrackSetSelectField;